import React, { memo, forwardRef } from "react";
const SvgCapitalC = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M17.26 23.44c-1.107 0-2.127-.18-3.06-.54a7.256 7.256 0 01-2.38-1.54A7.144 7.144 0 0110.26 19c-.373-.92-.56-1.933-.56-3.04 0-1.133.194-2.153.58-3.06.4-.92.94-1.7 1.62-2.34a7.303 7.303 0 012.44-1.48c.934-.347 1.947-.52 3.04-.52.814 0 1.587.12 2.32.36.747.227 1.354.54 1.82.94.24.213.393.407.46.58.067.16.1.313.1.46 0 .32-.113.593-.34.82-.213.227-.493.34-.84.34a1.23 1.23 0 01-.42-.08 2.905 2.905 0 01-.54-.32c-.28-.24-.646-.447-1.1-.62a3.952 3.952 0 00-1.46-.26c-.733 0-1.4.133-2 .4-.6.267-1.12.633-1.56 1.1a5.112 5.112 0 00-1 1.64 5.954 5.954 0 00-.34 2.04c0 .773.114 1.48.34 2.12a4.98 4.98 0 00.96 1.66c.427.453.934.807 1.52 1.06.587.253 1.247.38 1.98.38.56 0 1.08-.087 1.56-.26.494-.173.96-.453 1.4-.84.213-.187.387-.3.52-.34a1.23 1.23 0 01.42-.08c.307 0 .567.1.78.3.227.187.34.453.34.8 0 .16-.04.333-.12.52-.08.187-.213.373-.4.56-.453.44-1.067.82-1.84 1.14-.773.307-1.667.46-2.68.46z"
      />
    </svg>
  );
});
SvgCapitalC.displayName = "SvgCapitalC";
const MemoForwardRef = memo(SvgCapitalC);
export default MemoForwardRef;
